import React from "react";

function UploadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
    >
      <g clip-path="url(#clip0_2356_4149)">
        <path
          d="M4.76562 15C2.28125 15 0.265625 12.9844 0.265625 10.5C0.265625 8.5375 1.52187 6.86875 3.27187 6.25313C3.26875 6.16875 3.26562 6.08437 3.26562 6C3.26562 3.2375 5.50313 1 8.26562 1C10.1187 1 11.7344 2.00625 12.6 3.50625C13.075 3.1875 13.65 3 14.2656 3C15.9219 3 17.2656 4.34375 17.2656 6C17.2656 6.38125 17.1937 6.74375 17.0656 7.08125C18.8906 7.45 20.2656 9.06563 20.2656 11C20.2656 13.2094 18.475 15 16.2656 15H4.76562ZM7.23438 8.21875C6.94063 8.5125 6.94063 8.9875 7.23438 9.27812C7.52812 9.56875 8.00312 9.57187 8.29375 9.27812L9.5125 8.05937V12.25C9.5125 12.6656 9.84688 13 10.2625 13C10.6781 13 11.0125 12.6656 11.0125 12.25V8.05937L12.2312 9.27812C12.525 9.57187 13 9.57187 13.2906 9.27812C13.5812 8.98438 13.5844 8.50938 13.2906 8.21875L10.7906 5.71875C10.4969 5.425 10.0219 5.425 9.73125 5.71875L7.23125 8.21875H7.23438Z"
          fill="#9CA3AF"
        />
      </g>
      <defs>
        <clipPath id="clip0_2356_4149">
          <path d="M0.265625 0H20.2656V16H0.265625V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default UploadIcon;
